import HoverHandler from './src/hover-handler';
import { domReady } from './src/dom';

export default class LoadMoreHandler {
  constructor(settings) {
    this.container = document.querySelector(settings.container);
    this.childSelector = settings.childSelector;
    this.postType =
      settings.postType || this.container.getAttribute('data-post-type');
    this.perPage =
      settings.perPage || this.container.getAttribute('data-per-page');
    this.posts = this.container.getAttribute('data-category');
    this.category =
      settings.category || this.container.getAttribute('data-filter-category');
    this.totalAmount =
      settings.totalAmount || this.container.getAttribute('data-total-amount');
    this.page = parseInt(this.container.getAttribute('data-page'));
    this.loadMoreButton = this.container.querySelector('[data-load-more]');
    this.currentAmount = this.getCurrentElementAmount();
    this.tag = this.container.getAttribute('tag');
    this.categoryFilters = this.container.querySelectorAll(
      '[data-filter-category]'
    );

    domReady(() => {
      if (this.loadMoreButton !== null) {
        this.loadMoreButton.addEventListener('click', (e) =>
          this.loadMoreElements(e)
        );
      }
      this.categoryFilters.forEach((filter) => {
        filter.addEventListener('click', (e) => this.loadMoreElements(e));
      });
    });
  }

  getCurrentElementAmount() {
    let childElements = this.container.querySelectorAll(this.childSelector);
    return childElements.length;
  }

  getCurrentCategoryAmount() {
    let categoryAmount = this.container.querySelectorAll(this.childSelector);
    return categoryAmount;
  }

  loadMoreElements(e) {
    let instance = this;
    let ajaxUrl = document
      .querySelector('[data-ajax]')
      .getAttribute('data-ajax');
    let spinner = document.getElementById('spinner');

    if (instance.loadMoreButton !== null) {
      instance.loadMoreButton.style.display = 'none';
      spinner.style.display = 'block';
    }

    let data = {
      action: 'loadMorePosts',
      type: this.postType,
      perPage: this.perPage,
      page: this.page + 1,
      tag: this.tag,
      category: '',
    };

    let currentElement = e.currentTarget;
    let activeCategory = document.querySelector('.category-active');

    if (currentElement.hasAttribute('data-filter-category')) {
      data.category = currentElement.getAttribute('data-filter-category');
      data.page = 1;
    } else if (currentElement.hasAttribute('data-load-more')) {
      if (
        activeCategory !== null &&
        activeCategory.getAttribute('data-filter-category') !== 'all'
      ) {
        data.category = activeCategory.getAttribute('data-filter-category');
      }
    }

    let urlParameters = Object.entries(data)
      .map((e) => e.join('='))
      .join('&');
    let url = ajaxUrl + '?' + urlParameters;

    let xhr = new XMLHttpRequest();
    xhr.open('GET', url);
    xhr.onload = function () {
      if (xhr.status === 200) {
        let response = JSON.parse(xhr.responseText);
        if (response.success) {
          let doc = new DOMParser().parseFromString(response.data, 'text/html');
          let nodes = doc.querySelectorAll(instance.childSelector);

          if (instance.loadMoreButton !== null) {
            instance.loadMoreButton.style.display = 'block';
            spinner.style.display = 'none';
          }

          //polyfill for IE
          (function (arr) {
            arr.forEach(function (item) {
              if (item.hasOwnProperty('remove')) {
                return;
              }
              Object.defineProperty(item, 'remove', {
                configurable: true,
                enumerable: true,
                writable: true,
                value: function remove() {
                  if (this.parentNode !== null)
                    this.parentNode.removeChild(this);
                },
              });
            });
          })([
            Element.prototype,
            CharacterData.prototype,
            DocumentType.prototype,
          ]);

          if (currentElement.hasAttribute('data-filter-category')) {
            let posts = instance.container.querySelectorAll(
              '.posts>.post-preview'
            );

            posts.forEach((post) => {
              post.remove();
            });
          }

          nodes.forEach((node) => {
            instance.container.insertBefore(node, instance.loadMoreButton);
          });

          if (currentElement.hasAttribute('data-filter-category')) {
            instance.page = 1;
          } else {
            instance.page++;
          }

          instance.currentAmount = instance.getCurrentElementAmount();

          if (instance.currentAmount >= instance.totalAmount) {
            instance.loadMoreButton.style.display = 'none';
          }

          instance.postsMaxAmount = activeCategory.getAttribute(
            'data-max-posts'
          );

          if (
            activeCategory !== null &&
            activeCategory.getAttribute('data-filter-category') !== 'all'
          ) {
            if (
              instance.currentAmount >= instance.postsMaxAmount &&
              instance.loadMoreButton !== null
            ) {
              instance.loadMoreButton.style.display = 'none';
            } else {
              instance.loadMoreButton.style.display = 'block';
            }
          } else if (
            activeCategory.getAttribute('data-filter-category') === 'all'
          ) {
            if (instance.currentAmount >= instance.totalAmount) {
              instance.loadMoreButton.style.display = 'none';
            } else {
              instance.loadMoreButton.style.display = 'block';
            }
          }

          new HoverHandler(['a', '.post-preview']);
        }
      } else {
        console.log('error');
      }
    };
    xhr.send();
  }
}

new LoadMoreHandler({
  container: '[data-more-container]',
  childSelector: '.post-preview',
});
